module.exports = __webpack_public_path__ + "assets/img/img185.7ca60956.png";